import { useMutation, useQueryClient } from '@tanstack/react-query';
import { METHOD, sendRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import { GET_COMPOSITE_COMPONENTS_QUERY_KEY } from '@/state/queries/composite-components/use-get-composite-components';

export const useDeleteCompositeComponentMutation = () => {
  const { getToken } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: string) => {
      const token = await getToken();
      const url = `${import.meta.env.VITE_API_URL}/composite-components/${id}`;
      return sendRequest({ url, method: METHOD.DELETE, token: token ?? undefined });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_COMPOSITE_COMPONENTS_QUERY_KEY] });
    },
  });
};
